import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServicePathProviderService } from '@blk/cwp-ng-framework';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PartnerApiService {
	private readonly API_GATEWAY: string = 'api-gateway';
	private readonly API_BASE = '/iretire-server/advisor-center/';

	private readonly API = {
		FETCH_CREATE_UPDATE_MODEL: '/services/v2/models/',
		PROGRAM_HANDLES: '/services/v2/program-handles/',
		RISK_SCALES: '/services/v2/risk-scales/'
	};

	constructor(private http: HttpClient, private servicePathProvider: ServicePathProviderService) { }

	public fetchExternalModel(externalSource: string, externalModelId: string, overrideOnReimport: boolean = false): Observable<any> {
		let options = {};
		const url = this.getPartnerApiPath(externalSource, this.API.FETCH_CREATE_UPDATE_MODEL) + externalModelId;
		options = { params: { overrideOnReimport, usePas: true } };
		return this.http.get(url, options);
	}

	public fetchExternalModelList(externalSource: string): Observable<any> {
		const url: string = this.getPartnerApiPath(externalSource, this.API.FETCH_CREATE_UPDATE_MODEL);
		return this.http.get(url);
	}

	public createUpdateExternalModel(externalSource: string, portfolioId: string, portfolioJsonData?: any, externalModelId?: string): Observable<any> {
		const url: string = this.getPartnerApiPath(externalSource, this.API.FETCH_CREATE_UPDATE_MODEL);
		const params: any = {};
		if (portfolioId) {
			params.portfolioId = portfolioId;
			params.portfolioJsonData = portfolioJsonData;
			params.externalModelId = externalModelId;
		}
		return this.http.post(url, params);
	}

	public fetchExternalProgramHandles(externalSource: string): Observable<any> {
		const url: string = this.getPartnerApiPath(externalSource, this.API.PROGRAM_HANDLES);
		return this.http.get(url);
	}

	public fetchExternalRiskScales(externalSource: string): Observable<any> {
		const url: string = this.getPartnerApiPath(externalSource, this.API.RISK_SCALES);
		return this.http.get(url);
	}

	private getPartnerApiPath(externalSource: string, apiPath: string): string {
		return this.servicePathProvider.getServicePath(this.API_GATEWAY) + this.API_BASE + externalSource + apiPath;
	}
}
